<template>
  <section class="parceiros-container rounded-default p-4 mr-4 cursor-pointer">
    <div class="flex flex-row mb-5 justify-between">
      <span class="partners-title">{{ data.variante_tipo.descricao }}</span>
      <span class="btn-edit ml-1 flex justify-center items-center justify-center rounded-default">
        <span class="edit-icon" @click="$emit('delete', data.id)">
          <feather class="trash-icon" type="trash-2" size="12px" />
        </span>
      </span>
    </div>
  </section>
</template>

<script>
import global from '@/mixins/global';

export default {
	name: 'TipoVariante',
	mixins: [global],
	props: {
		data: {
			type: Object,
			required: true,
			default: () => ({}),
		},
	},
	data() {
		return {};
	},
	watch: {},
	methods: {
		dropdownActions(value) {
			this.$emit('dropdown-action', {
				action: 'delete',
				data: value,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/style/Global.css';
.parceiros-container {
	background-color: var(--white-color);
	box-sizing: border-box;
	width: 24%;
	margin-bottom: 40px;
	transition: ease-in-out 0.2s;
	flex-wrap: wrap;
	border: 2px solid var(--white-color);
	box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.btn-edit {
	background-color: var(--secondary-color);
	height: 25px;
}

.edit-icon {
	width: 25px;
	height: 20px;
	transition: ease-in-out 0.2s;
	display: flex;
	align-items: center;
	justify-content: center;
	&:hover {
		background-color: darken(#e2eaf5, 10%);
	}
}

.trash-icon {
	color: #e63946;
}

.parceiros-container:hover {
	box-shadow: var(--default-shadow);
}

.partners-title {
	font-weight: bold;
	font-size: 14px;
	color: #010101;
}

</style>
